import { InterestLevelLimitType, OfferingType } from '../../../graphql';
import {
  BLOCK_OFFERING_TYPES,
  FOLLOW_ON_OFFERING_TYPES,
  IPO_OFFERING_TYPES,
  offeringTypeLabels,
} from '../../../types/domain/offering/constants';
import { limitTypeLabels } from '../../../types/domain/order-book/constants';

export function getOfferingTypeLabel(offeringType: OfferingType | string): string {
  return offeringTypeLabels[offeringType] ?? 'UNKNOWN_VALUE';
}

export function isIPOType(type: OfferingType | undefined | null) {
  if (!type) {
    return false;
  }

  return IPO_OFFERING_TYPES.includes(type);
}

export function isFOType(type: OfferingType | undefined | null) {
  if (!type) {
    return false;
  }

  return FOLLOW_ON_OFFERING_TYPES.includes(type);
}

export function isBlockType(type: OfferingType | undefined | null) {
  if (!type) {
    return false;
  }

  return BLOCK_OFFERING_TYPES.includes(type);
}

export const limitTypeOptions = {
  Price: {
    label: limitTypeLabels[InterestLevelLimitType.Price],
    value: InterestLevelLimitType.Price,
  },
  Discount: {
    label: limitTypeLabels[InterestLevelLimitType.Discount],
    value: InterestLevelLimitType.Discount,
  },
  Premium: {
    label: limitTypeLabels[InterestLevelLimitType.Premium],
    value: InterestLevelLimitType.Premium,
  },
};

export function getLimitTypesForOffering(offeringType: OfferingType) {
  switch (offeringType) {
    case OfferingType.Ipo:
    case OfferingType.IpoSpac:
      return [limitTypeOptions.Price];
    default:
      return [limitTypeOptions.Price, limitTypeOptions.Discount, limitTypeOptions.Premium];
  }
}

export function getDefaultLimitTypeForOffering(offeringType: OfferingType) {
  const offeringTypes = getLimitTypesForOffering(offeringType);
  return offeringTypes.length === 1 ? offeringTypes[0].value : null;
}
